import { IP_COUNTRY_QUERY, USER_COUNTRY_QUERY, USER_UPDATED, USER_QUERY, USER_COUNTRY_UPDATED } from '@gig/magic-messages';
import { IP_COUNTRY_COOKIE } from './country.constants.js';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class CountryService {
  constructor(cookie) {
    this.cookie = cookie;
    this.cookieCountry = null;
    this.cookieCountry = this.readCookie();
    this.registerCookieCountryQuery();
    this.registerUserCountryQuery();
    this.subscribeToUserCountryChanges();
  }
  getCookieCountry() {
    return this.cookieCountry;
  }
  readCookie() {
    const ipCookie = this.cookie.read(IP_COUNTRY_COOKIE);
    if (!ipCookie) {
      return null;
    }
    return ipCookie.toUpperCase();
  }
  registerCookieCountryQuery() {
    window.queryBus.subscribe(IP_COUNTRY_QUERY, () => {
      return this.cookieCountry;
    });
  }
  registerUserCountryQuery() {
    window.queryBus.subscribe(USER_COUNTRY_QUERY, () => __async(this, null, function* () {
      const user = yield this.getUser();
      return this.getUserCountry(user);
    }));
  }
  subscribeToUserCountryChanges() {
    this.getUser().then((user) => {
      this.publishUserCountry(user);
      window.eventBus.subscribe(USER_UPDATED, (event) => {
        this.publishUserCountry(event.payload);
      });
    });
  }
  getUser() {
    return window.queryBus.query(USER_QUERY);
  }
  publishUserCountry(user) {
    window.eventBus.publish(USER_COUNTRY_UPDATED, this.getUserCountry(user));
  }
  getUserCountry(user) {
    var _a;
    return user ? user.country : (_a = this.cookieCountry) != null ? _a : null;
  }
}

export { CountryService };
